import dynamic from 'next/dynamic';

const ShowcaseEmbedComponent = dynamic(
  () => import('../../../../libs/showcase-layout/ShowcaseEmbedWrapper'),
  { ssr: false },
);

const EmbedPage = () => {
  return <ShowcaseEmbedComponent />;
};

export default EmbedPage;
